import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Account, Dictionary, Section } from '../models';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  constructor(
    private readonly http: HttpClient,
    @Inject('apiBaseUrl') private readonly apiBaseUrl: string,
  ) {}

  getAccounts(accountQuery: string) {
    return this.http.get<Account[]>(`${this.apiBaseUrl}accounts`, {
      params: new HttpParams({
        fromObject: {
          q: accountQuery || '',
        },
      }),
    });
  }

  getSections(account: string) {
    return this.http.get<Dictionary<Section>>(
      `${this.apiBaseUrl}accounts/${account}/sections`,
    );
  }
}
